export default {
      id: "time-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.svg#time",
      toString: function () {
        return this.url;
      }
    }